import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { messages } from './messages';

export const AddressLine1 = {
  id: 'addressLine1',
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'AddressLine1',
  displayName: <FormattedMessage {...messages.addressLine1} />,
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
